export class PayTimeRangeType {
  static get OneToThirty () {
    return 1
  }
  static get TwentyOneToTwenty () {
    return 3
  }

  static PayTimeRangeTypeName (payTimeRangeType) {
    let tmpType = parseInt(payTimeRangeType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '1-30'
        break
      case 3:
        name = '21-20'
        break
    }
    return name
  }
}
